export default __webpack_public_path__ + "static/ford-936f5220aef445012d3b127e2ff2f792.svg";